/*
 * Project: BookingEngine
 * Module: components/booking/rooms/ViewingHotel.js
 */
import React from 'react';
import PropTypes from 'prop-types';
import ReactTimeout from 'react-timeout';

import '../../../static/less/hotel/viewing-hotel.less';

class ViewingHotel extends React.Component {
  constructor(props) {
    super(props);

    this.state = { show: false };
    this.timeout1 = null;
    this.timeout2 = null;
  }

  componentDidMount() {
    this.timeout1 = this.props.setTimeout(() => {
      this.setState({ show: true });

      // Lo desactivamos al cabo de un rato
      this.timeout2 = this.props.setTimeout(() => {
        // eslint-disable-next-line react/no-string-refs
        jQuery(this.refs.ViewingHotel).fadeOut(() => {
          this.setState({ show: false });
        });
      }, 10000);
    }, 4000);
  }

  componentWillUnmount() {
    // Avoid issues if component is unmounted by moving to another page
    this.props.clearTimeout(this.timeout1);
    this.props.clearTimeout(this.timeout2);
  }

  onClose = () => {
    this.setState({ show: false });
  };

  render() {
    if (this.props.howMany <= 1 || !this.state.show) {
      return null;
    }

    return (
      // eslint-disable-next-line react/no-string-refs
      <div className="ViewingHotel animated bounceInLeft" ref="ViewingHotel" onClick={this.onClose}>
        {this.context.t('{n} people are checking this hotel', { n: this.props.howMany })}
      </div>
    );
  }
}

ViewingHotel.contextTypes = {
  t: PropTypes.func.isRequired,
};

ViewingHotel.propTypes = {
  howMany: PropTypes.number.isRequired,
};

export default ReactTimeout(ViewingHotel);
